import React from "react";
import isEqual from "lodash/isEqual";
import { connect } from "react-redux";
import Element from "@whalecloud/page-builder-core/components/Element";
import { getElement } from "@whalecloud/page-builder-core/selectors";
import { PbElement } from "@whalecloud/page-builder-core/utils/types";

type ColumnChildProps = {
    element: PbElement;
    index: number;
    last: boolean;
    target: { type: string };
    dropElementAbove: Function;
    dropElementBelow: Function;
};

const BodyChild = (props: ColumnChildProps) => {
    const { target, element, last = false } = props;

    return (
        <div style={{ width: "100%", position: "relative" }}>
            <Element id={element.id} />
        </div>
    );
};

const mapDispatchToProps = (dispatch: any) => ({
  dropElement: (payload: any) => {
    dispatch({
      type: 'appBuilder/dropElement',
      payload,
    });
  },
});

export default connect<any, any, any>(
    (state, props) => ({
        element: getElement(state, props.id)
    }),
    mapDispatchToProps,
    null,
    { areStatePropsEqual: isEqual }
)(React.memo(BodyChild));
